//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/AME.js";
import "../no/Builder.js";
import "../Annotations/Annotations.OriginBuilder.js";
import "../AME/AME.SymbolAnnotationStyleBuilder.js";
import "../no/Annotations.js";
let d=[[[0,"ContactBlock",1,0],[1,"Origin",0,"Annotations.OriginBuilder",0],[1,"SymbolAnnotationStyle",0,"AME.SymbolAnnotationStyleBuilder",0],[0,"TextBoxWidth",1,0],[0,"TextOverflow",1,0],[0,"Type",1,0]],[[["propertyName","propertyReference"],"AddAttribute",{},2,0],[[],"ResetPropertyList",{},0,0],[[],"ResetToDefault",{},0,0],[["attrOwner","attrTitle","attrCategory"],"AddNewAttribute",{},3,0],[["attrIndex"],"RemoveAttribute",{},1,0],[["attrIndex"],"MoveUpAttribute",{},1,0],[["attrIndex"],"MoveDownAttribute",{},1,0],[["attrIndex","attrCategory"],"UpdateAttributeCategory",{},2,0],[["noteString"],"SetNoteString",{},1,0]],[]];
SPLM.AME.SymbolNoteBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.AME.SymbolNoteBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;